import { connect } from 'react-redux';
import { ApplicationState } from '../../../redux/reducers';
import UserProfile from './UserProfile';
import { getIssuer, updateIssuer,deleteIssuer } from '../../../redux/auth/creators';
import { getDashboardInfo } from '../../../redux/ui/creators';
interface StateProps {
  auth: any;
}

interface DispatchProps {
  getIssuer: Function;
  updateIssuer: Function;
  deleteIssuer: Function;
  getDashboardInfo: Function;
}

interface OwnProps {}

export type AllProps = StateProps & DispatchProps & OwnProps;

const mapStateToProps = (state: ApplicationState) => {
  return {
    auth: state.auth
  }
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    getIssuer: dispatch(getIssuer),
    updateIssuer: dispatch(updateIssuer),
    deleteIssuer: dispatch(deleteIssuer),
    getDashboardInfo: dispatch(getDashboardInfo),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserProfile);